import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import '../../../../../../../context/actions.js';
import '../../../../../../../context/reducer.js';
import { useContactLensProductData } from '../../../../../../../context/product-context-hooks.js';
import '../../../../../../../context/ProductContext.js';
import '../../../../../../../context/CmsContext.js';
import '@grandvisionhq/analytics';
import '@swc/helpers';
import { pushContactLensesChangeQuantityEvent } from '../../../../../../Analytics/events/change-quantity-events.js';
import '../../../../../../../types/product.js';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/utils';
import '@grandvisionhq/graphql';
import '@grandvisionhq/svc-tealium/utils';
import '../../../../../../../hooks/useCartDiscountsQuery/types.js';
import '../../../../../../../operations/queries/get-accessories-by-slug.js';
import '../../../../../../../operations/queries/get-contact-lens-by-slug.js';
import '../../../../../../../operations/queries/get-frames-by-slug.js';
import '../../../../../../../operations/queries/get-solutions-by-slug.js';
import '../../../../../../../operations/queries/get-sunglasses-by-slug.js';
import '../../../../../../../operations/queries/get-ready-reader-by-slug.js';
import '../../../../../../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import '../../../../../../../operations/queries/get-manufacturer-by-key.js';
import '../../../../../../../hooks/use-product-view-history.js';
import '@grandvisionhq/frk-routing';
import 'classnames';
import '@grandvisionhq/common';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import '@grandvisionhq/forms';
import '@grandvisionhq/inventory';
import '@grandvisionhq/lib-utils-html';
import '../../../../../../VTO/context/VtoProvider.js';
import 'usehooks-ts';
import 'use-onclickoutside';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/lib-visuals';
import '../../../../../../../slots/context.js';
import '@grandvisionhq/content';
import { useCLEcommContext } from '../../../../context/CLEcommContext.js';
import { CLQuantitySelector } from './CLQuantitySelector.js';
import { createOptionsList } from './create-options-list.js';

const CLQuantitySelectorContainer = /*#__PURE__*/ React.memo(({ eyeSideId , className , isEnabled  })=>{
    const { getLabel  } = useIntl();
    const { activeVariant  } = useContactLensProductData();
    const { actions , state , triggerToastMessage  } = useCLEcommContext();
    const { quantitySelector  } = state.configurator[eyeSideId];
    const { maxSelectableQuantity , selectionInvalidatedCount  } = quantitySelector;
    const { purchaseType  } = state.configurations;
    const { quantity: selectedQuantity  } = state.configurations[eyeSideId];
    const { lensesPerBox  } = activeVariant;
    const options = createOptionsList({
        maxSelectableQuantity,
        lensesPerBox,
        getLabel
    });
    React.useEffect(()=>{
        /**
       * This toast notifies the user when we have automatically adjusted the selected quantity
       * This can happen when the user has selected a quantity that is no longer available
       */ if (!!selectionInvalidatedCount) {
            triggerToastMessage('quantity-invalidated-warning');
        }
    }, [
        selectionInvalidatedCount
    ]);
    const handleQuantityChange = React.useCallback((quantity)=>{
        actions.updateSelectedQuantity(eyeSideId, quantity);
        pushContactLensesChangeQuantityEvent({
            quantity,
            purchaseType,
            eyeSide: eyeSideId
        });
    }, []);
    return /*#__PURE__*/ React.createElement(CLQuantitySelector, {
        className: className,
        parentId: eyeSideId,
        onChange: handleQuantityChange,
        selectedQuantity: selectedQuantity,
        options: options,
        isDisabled: !isEnabled || !maxSelectableQuantity
    });
});

export { CLQuantitySelectorContainer };
//# sourceMappingURL=CLQuantitySelectorContainer.js.map
